import React from 'react'
import { ArrowLeft } from 'lucide-react'
import { Button } from './Button'

interface PageHeaderProps {
 title: string
 subtitle?: string
 onBack?: () => void
 backLabel?: string
 children?: React.ReactNode
}

export const PageHeader: React.FC<PageHeaderProps> = ({
 title,
 subtitle,
 onBack,
 backLabel = 'Voltar',
 children
}) => {
 return (
 <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
 <div className="flex items-center space-x-4">
 {onBack && (
 <Button
 type="button"
 variant="outline"
 onClick={onBack}
 >
 <ArrowLeft className="h-4 w-4 mr-2" />
 {backLabel}
 </Button>
 )}
 <div>
 <h1 className="text-2xl font-bold text-foreground">
 {title}
 </h1>
 {subtitle && (
 <p className="text-muted-foreground">
 {subtitle}
 </p>
 )}
 </div>
 </div>
 {children && (
 <div className="mt-4 sm:mt-0">
 {children}
 </div>
 )}
 </div>
 )
}

